import go from 'dea-core';
import data from './data';

go(data);



// WEBPACK FOOTER //
// ./src/index.js